import React from 'react';
import MembersContext from './MembersContext';

export default function useMembers() {
    return React.useContext(MembersContext);
}